// Brand-specific iframe configuration
const BRAND_IFRAME_CONFIG = {
  // GIH (Gisma University of Applied Sciences) configuration
  GIH_OAP: {
    type: 'CUSTOM_API',
    dev: {
      baseUrl: 'https://ghs.app-form.richbrains.net',
      createApiEndpoint: '/iframe/application/create',
      updateApiEndpoint: '/iframe/application/update',
      changeApiEndPoint: '/iframe/application/review',
      authMethod: 'JWT_TOKEN',
    },
    prod: {
      baseUrl: 'https://apply.gisma.com',
      createApiEndpoint: '/iframe/application/create',
      updateApiEndpoint: '/iframe/application/update',
      changeApiEndPoint: '/iframe/application/review',
      authMethod: 'JWT_TOKEN',
    },
  },
  // Berlin School of Business and Innovation configuration
  'Berlin School of Business and Innovation_OAP': {
    type: 'CUSTOM_API',
    dev: {
      baseUrl: 'https://bsbi.app-form.richbrains.net',
      createApiEndpoint: '/iframe/application/create',
      updateApiEndpoint: '/iframe/application/update',
      changeApiEndPoint: '/iframe/application/review',
      authMethod: 'JWT_TOKEN',
    },
    prod: {
      baseUrl: 'https://start.berlinsbi.com',
      createApiEndpoint: '/iframe/application/create',
      updateApiEndpoint: '/iframe/application/update',
      changeApiEndPoint: '/iframe/application/review',
      authMethod: 'JWT_TOKEN',
    },
  },
}

// Legacy OAP URL configuration for existing brands
const OAP_URL = {
  UCW_AGENT_PORTAL_DEV: 'https://ucw-oap-dev.apphero.io',
  UCW_OAP_DEV: 'https://apply-dev.ucanwest.ca',
  UCW_AGENT_PORTAL_PROD: 'https://ucw-oap.apphero.io',
  UCW_OAP_PROD: 'https://apply.ucanwest.ca',
  // UEG
  UEG_AGENT_PORTAL_DEV: 'https://ue-oap-dev.apphero.io',
  UEG_OAP_DEV: 'https://apply-dev.ue-germany.com',
  UEG_AGENT_PORTAL_PROD: 'https://ue-oap.apphero.io',
  UEG_OAP_PROD: 'https://apply.ue-germany.com',
  // UNFC
  UNFC_AGENT_PORTAL_DEV: 'https://unf-oap-dev.apphero.io',
  UNFC_OAP_DEV:'https://apply-dev.myunfc.ca',
  UNFC_AGENT_PORTAL_PROD: 'https://unf-oap.apphero.io',
  UNFC_OAP_PROD: 'https://apply.myunfc.ca',
}

const OAP_CHANGE_REQUEST_PORTALS = new Set(['UNFC_OAP'])

const getOpportunityPortalKey = (opportunity) => {
  if (
    !opportunity?.BusinessUnitFilter__c ||
    !opportunity?.ApplicationSource__c
  ) {
    return ''
  }

  return `${
    opportunity.BusinessUnitFilter__c
  }_${opportunity?.ApplicationSource__c?.replace(' ', '_').toUpperCase()}`
}

/**
 * Determine the current environment stage (DEV or PROD)
 * Falls back to hostname checking if env variable is missing
 */
const getEnvironmentStage = () => {
  const envStage = process.env.REACT_APP_STAGE?.toUpperCase()
  if (envStage) return envStage

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const hostname = window.location.hostname.toLowerCase()
    if (
      hostname.includes('localhost') ||
      hostname.includes('dev') ||
      hostname.includes('uat') ||
      hostname.includes('stage')
    ) {
      return 'DEV'
    }
    return 'PROD'
  }
  return 'DEV'
}

/**
 * Get brand-specific iframe configuration
 * @param {Object} opportunity - The opportunity object
 * @returns {Object|null} Brand configuration or null if not found
 */
export const getBrandIframeConfig = (opportunity) => {
  if (!opportunity?.BusinessUnitFilter__c) return null

  const urlKey = getOpportunityPortalKey(opportunity);
  const brandConfig = BRAND_IFRAME_CONFIG[urlKey]
  if (!brandConfig) return null

  const stage = getEnvironmentStage().toLowerCase()
  return {
    ...brandConfig,
    config: brandConfig[stage] || brandConfig.dev,
  }
}

/**
 * Check if a brand uses custom iframe workflow
 * @param {Object} opportunity - The opportunity object
 * @returns {boolean} True if brand uses custom workflow
 */
export const usesCustomIframeWorkflow = (opportunity) => {
  const brandConfig = getBrandIframeConfig(opportunity)
  return brandConfig?.type === 'CUSTOM_API'
}

export const getOAPUrl = (opporunity) => {
  if (
    !opporunity ||
    !opporunity?.BusinessUnitFilter__c ||
    !opporunity?.ApplicationSource__c
  )
    return ''

  // Check if this brand uses custom iframe workflow
  if (usesCustomIframeWorkflow(opporunity)) {
    const brandConfig = getBrandIframeConfig(opporunity)
    return brandConfig?.config?.baseUrl || ''
  }

  // Use legacy URL mapping for existing brands
  const urlKey = getOpportunityPortalKey(opporunity)
  const stage = getEnvironmentStage()
  return OAP_URL[`${urlKey}_${stage}`]
}

export const supportsOapChangeRequest = (opportunity) => {
  const portalKey = getOpportunityPortalKey(opportunity)
  console.log("portalKey -> ",portalKey)
  return OAP_CHANGE_REQUEST_PORTALS.has(portalKey)
}